import { LocaleActionTypes } from './types';

export const changeLocale = (locale: string): { type: LocaleActionTypes; payload: string } => ({
  type: LocaleActionTypes.ChangeLocale,
  payload: locale,
});
